import React from "react";
import { Building2, ChevronRight, MessageCircle, Phone } from "lucide-react";

function ActiveConnection({
  status,
  workspaceName,
  accountName,
  phoneName,
  phoneNumber,
}) {
  return (
    <section>
      <div className="relative overflow-hidden rounded-[22px] border border-[#cfe4ed] bg-[linear-gradient(118deg,#edf8fd_0%,#ffffff_56%,#f8fbfc_100%)] p-4 shadow-[0_14px_40px_rgba(15,43,66,0.06)] sm:p-5 dark:border-dark-border dark:bg-[linear-gradient(118deg,#123a55_0%,#142330_58%,#192b39_100%)]">
        {/* Decorative Circle */}
        <div className="absolute -right-12 -top-16 h-36 w-36 rounded-full border border-[#b9dff0] sm:h-40 sm:w-40 dark:border-dark-primary/35" />

        <div className="relative">
          {/* Header */}
          <div className="mb-3.5 flex items-start justify-between gap-3 sm:mb-4">
            <div className="min-w-0">
              <div className="flex items-center gap-1.5 sm:gap-2">
                <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-[#2fa879] shadow-[0_0_0_4px_rgba(47,168,121,0.10)] sm:h-2 sm:w-2 dark:bg-[#69c49e]" />

                <p className="truncate text-[9px] font-bold uppercase tracking-[0.13em] text-[#4f758a] sm:text-[10px] dark:text-dark-text-secondary">
                  Selected connection
                </p>
              </div>

              <h3 className="mt-1.5 truncate text-[12px] font-semibold text-text-primary sm:mt-2 sm:text-sm dark:text-dark-text-primary">
                {phoneName}
              </h3>
            </div>

            {/* Connected Badge */}
            <div className="flex shrink-0 items-center gap-1 rounded-full border border-[#afe0c5] bg-[#eefaf4] px-2.5 py-1 text-[8px] font-bold text-[#167a59] sm:text-[9px] dark:border-[#28624d] dark:bg-[#16352a] dark:text-[#65cda7]">
              <span className="h-1.5 w-1.5 rounded-full bg-[#2fa879]" />
              {status}
            </div>
          </div>

          {/* Connection Path */}
          <div className="grid gap-2 sm:grid-cols-[1fr_auto_1fr_auto_1fr] sm:items-center">
            {/* Workspace */}
            <span className="flex min-w-0 items-center gap-2 rounded-xl border border-white/90 bg-white/80 px-3 py-2.5 text-[9px] font-semibold text-[#526b7b] dark:border-dark-border dark:bg-dark-surface dark:text-dark-text-secondary">
              <Building2 size={13} className="shrink-0 text-[#6f91a5]" />
              <span className="truncate">{workspaceName || "Workspace"}</span>
            </span>

            <ChevronRight
              size={11}
              strokeWidth={1.8}
              className="mx-auto hidden shrink-0 text-[#9badb8] sm:block"
            />

            {/* Account */}
            <span className="flex min-w-0 items-center gap-2 rounded-xl border border-white/90 bg-white/80 px-3 py-2.5 text-[9px] font-semibold text-[#526b7b] dark:border-dark-border dark:bg-dark-surface dark:text-dark-text-secondary">
              <MessageCircle size={13} className="shrink-0 text-[#6f91a5]" />
              <span className="truncate">
                {accountName || "WhatsApp Account"}
              </span>
            </span>

            <ChevronRight
              size={11}
              strokeWidth={1.8}
              className="mx-auto hidden shrink-0 text-[#9badb8] sm:block"
            />

            {/* Phone */}
            <span className="flex min-w-0 items-center gap-2 rounded-xl border border-[#b9dff0] bg-[#edf8fd] px-3 py-2.5 text-[9px] font-bold text-[#147db5] dark:border-dark-primary/45 dark:bg-dark-soft-blue dark:text-dark-primary">
              <Phone size={13} className="shrink-0" />
              <span className="truncate">{phoneNumber || "Phone number"}</span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ActiveConnection;
